import { AudioWaveform, Award, BookOpen, Crown, FolderTree, GraduationCap, Send, Sparkles, Trophy, UsersRound } from 'lucide-react'
import { AppShell, type ShellNavigationItem } from '@/platform/shell/AppShell'
import { featureManifests } from '@/app/navigation/manifests'
import { ttsNavigationItems } from '@/features/tts/public'

const FEATURE_ICONS: Record<string, typeof FolderTree> = {
  subjects: BookOpen,
  taxonomies: FolderTree,
  courses: GraduationCap,
  'membership-plans': Crown,
  'user-memberships': UsersRound,
  'learner-rewards': Sparkles,
  achievements: Award,
  'user-achievements': Trophy,
  tts: AudioWaveform,
  publish: Send,
}

const navigation: ShellNavigationItem[] = featureManifests.map((feature) => ({
  id: feature.id,
  path: feature.navPath,
  label: feature.label,
  Icon: FEATURE_ICONS[feature.id] || FolderTree,
  children: feature.id === 'tts' ? ttsNavigationItems : undefined,
}))

export function AppShellLayout() {
  return <AppShell homePath="/courses" navigation={navigation} />
}
